var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.98 54.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1034.08-102.27c-5.41,13.22-22.7,16.9-35.29,11.73s-18.41-20.06-13-33.27,20-19.74,32.61-14.58S1039.5-115.48,1034.08-102.27Z",
    transform: "translate(-982.27 141.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 987.08,
    y: -115.25,
    width: 2.53,
    height: 2.52,
    transform: "translate(108.73 1017.26) rotate(-89.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.56 18.36 7.42 17.07 8.71 14.9 10.85 16.18 9.56 18.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 989.94,
    y: -104.17,
    width: 2.53,
    height: 2.53,
    transform: "translate(-805.16 613.49) rotate(-29.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.85 10.35 15.62 8.14 17.82 6.91 19.06 9.08 16.85 10.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.34 48.67 15.2 47.38 16.49 45.21 18.63 46.5 17.34 48.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.59 10.56 29.77 10.54 29.57 27.72 31.36 30.97 29.52 32.1 26.78 32.07 26.82 28.29 22.09 19.88 20.48 20.75 20.16 13.62 26.09 17.62 24.48 18.53 26.88 22.75 27.02 10.51 25.2 10.48 28.47 4.1 31.59 10.56"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1008.95,
    y: -92.9,
    width: 2.53,
    height: 2.53,
    transform: "translate(108.01 1061.21) rotate(-89.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1020.03,
    y: -95.73,
    width: 2.53,
    height: 2.53,
    transform: "translate(-805.46 629.27) rotate(-29.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.77 9.29 39.05 7.15 41.23 8.44 39.94 10.58 37.77 9.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1028.21,
    y: -103.73,
    width: 2.53,
    height: 2.53,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, -388.71, 977.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1028.5,
    y: -125.85,
    width: 2.53,
    height: 2.53,
    transform: "translate(-789.65 629.55) rotate(-29.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1031.37,
    y: -114.74,
    width: 2.52,
    height: 2.53,
    transform: "translate(151.95 1062.05) rotate(-89.34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.8dbeba81.svg";
export { ForwardRef as ReactComponent };